// extracted by mini-css-extract-plugin
var _1 = "ZyvwaocO91B5xVZ3JYgn";
var _2 = "ZY1_LnURWEDMOkO1hLGF";
var _3 = "ir_XGRS98Tv_RYUQSu8F";
var _4 = "EGoyV001T7qdEiHGg4JR";
export { _1 as "gridH", _2 as "gridV", _3 as "horizontal", _4 as "vertical" }
